import React from 'react';
import { useSelector } from 'react-redux';
import { formatCurrency } from '../../lib/formatters';

export default function PrequalResponse() {
  const prequalification = useSelector(state => state.entities.get('prequalification').last());

  if (prequalification.status === 'pass') {
    return (<div className="has-text-centered">
      <div className="is-size-4 has-text-weight-bold">You're good to go</div>
      <div className="has-text-grey mb-6">We told you it would be easy.</div>

      <img alt="success icon" src="https://creditkey-assets.s3-us-west-2.amazonaws.com/cloud-check.svg" />
      <div className="text-green-highlight has-text-weight-bold is-size-2">PRE-APPROVED</div>
      <div className="is-size-5 has-text-weight-bold">Purchases up to {formatCurrency(prequalification.estimated_tcl)}</div>
      <div className="has-text-grey">Simply choose <strong>Credit Key</strong> at checkout</div>
    </div>);
  } else {
    return (<div className="has-text-centered">
      {prequalification.company_name} would most likely not qualify for Credit Key terms. [Minimum owner FICO score is 600.][Minimum annual revenue is $40,000.]
    </div>);
  }
}
